import React from 'react'

const AddAmigos = () => {
  return (
    <div>AddAmigos</div>
  )
}
export default AddAmigos